import {CANCEL_REDIRECT, PROFILE_CHANGE_REQUEST, PROFILE_CHANGE_REQUEST_ERROR, PROFILE_CHANGE_REQUEST_SUCCESS} from './Constants';

export const profileChangeRequest = (payload) => ({
    type: PROFILE_CHANGE_REQUEST,
    payload : payload
});

export const profileChangeRequestSuccess = (msg) => ({
    type: PROFILE_CHANGE_REQUEST_SUCCESS,
    msg : msg
});

export const profileChangeRequestError = () => ({
    type: PROFILE_CHANGE_REQUEST_ERROR,
});

export const cancelRedirect = () => ({
    type: CANCEL_REDIRECT,
    msg : null
});